export default __webpack_public_path__ + "static/media/dialogosLogo.0ea80a2b.png";